import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsNotification from './components/Settings/SettingsNotification'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  saveNotificationMode, updateNotificationMode
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsNotificationContainer extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("Notification Mode"))
  }

  handleSubmit(cb) {
    this.props.dispatch(saveNotificationMode(this.props.settings.notification_mode))
      .then(() => cb())
  }

  handleSelect(key) {
    this.props.dispatch(updateNotificationMode(key))
  }

  render() {
    return <SettingsStep onSubmit={this.handleSubmit} {...this.props}>
      <SettingsNotification onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsNotificationContainer)
